// extracted by mini-css-extract-plugin
export var chip = "_5i-9";
export var chipLabel = "_5i-a";
export var close = "_5i-7";
export var closeIcon = "_5i-8";
export var error = "_5i-6";
export var infoTooltip = "_5i-2";
export var innerContainer = "_5i-1";
export var input = "_5i-b";
export var medium = "_5i-5";
export var outerContainer = "_5i-0";
export var small = "_5i-4";
export var xSmall = "_5i-3";